<template>
  <v-sheet max-width="1024" width="auto" height="auto" color="transparent">
    <a
      :href="mainPageAd.url"
      target="_blank"
      @click="
        onClick();
        $gtag.navigation('click_sponsor_link', mainPageAd.url);
      "
    >
      <v-img :src="mainPageAd.file"></v-img>
    </a>
  </v-sheet>
</template>
<script>
export default {
  props: {
    mainPageAd: {},
  },
  data: () => ({}),
  methods: {
    onClick() {
      this.$emit('clicked');
    },
  },
};
</script>
